module.exports = __webpack_public_path__ + "static/media/icon-badge.7425e9cb.svg";